// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * This module provides workspace filter actions.
 *
 * @module js/swf3dWorkspaceFilterActions
 */

// Import from Apollo: the module from Apollo's library.
import eventBus from 'js/eventBus';
import uwPropertySvc from 'js/uwPropertyService';
import appCtxSvc from 'js/appCtxService';

// Import from js: file from Galaxy.
import utils from 'js/swf3dWorkspaceUtils';
import config from 'js/swf3dWorkspaceConfig';
import dataset from 'js/swf3dWorkspaceDataset';

let exports;
let _isLoading = false;

/**
 * Method for render UI filter list.
 *
 * @memberof js/swf3dWorkspaceFilterActions
 * @function renderFilterList
 * @example
 * swf3dWorkspaceFilterActions.renderFilterList();
 * @returns {object} - filter list data
 */
let renderFilterList = () => {
    if (!utils.isPresent(dataset.filterVMList)) {
        dataset.filterVMList = config.tableFilterList.map((item, index) => {
            let vmProp = uwPropertySvc.createViewModelProperty(item, item, 'BOOLEAN', true, ['true']);
            uwPropertySvc.setPropertyLabelDisplay(vmProp, 'PROPERTY_LABEL_AT_RIGHT');
            uwPropertySvc.setEditable(vmProp, true);
            return vmProp;
        });
    }
    return { filterList: dataset.filterVMList };
};

/**
 * This function will be triggered when filter list changed.
 *
 * @memberof js/swf3dWorkspaceFilterActions
 * @function selectTransferDestination
 * @param {object} data
 * @example
 * swf3dWorkspaceFilterActions.selectTransferDestination(data);
 */
let selectTransferDestination = data => {
    if (_isLoading === false) {
        let filterList = [];
        data.filterList.forEach((element, index, theArray) => {
            if (element.uiValue === 'true') {
                filterList.push(element.propertyName);
            }
            // Disable check box.
            theArray[index].isEnabled = false;
        });

        // Update filter list.
        appCtxSvc.updatePartialCtx('galaxy.workspace.table.currentFilterList', filterList);
        // Reload workspace.
        eventBus.publish('galaxy.workspace.resetTable');

        // Update data.
        _isLoading = true;
        dataset.filterVMList = data.filterList;
    }
};

/**
 * This function will be triggered when filter panel load successful.
 *
 * @memberof js/swf3dWorkspaceFilterActions
 * @function loadingSuccess
 * @param {object} data
 * @example
 * swf3dWorkspaceFilterActions.loadingSuccess(data);
 */
let loadingSuccess = data => {
    _isLoading = false;
    dataset.filterVMList.forEach((element, index, theArray) => {
        theArray[index].isEnabled = true;
    });
};

export default exports = {
    // impl
    renderFilterList,
    selectTransferDestination,
    loadingSuccess
};
